import { jsx as b, jsxs as M } from "react/jsx-runtime";
import { createContext as A, useContext as O } from "react";
import { CssBaseline as T, useMediaQuery as y } from "@mui/material";
import { createTheme as W, ThemeProvider as j, useTheme as R } from "@mui/material/styles";
const u = {
  standard: "standard",
  chat_ui: "chat-ui",
  global_head: "global-head"
}, r = {
  extra_small: "xs",
  small: "sm",
  medium: "md",
  large: "lg",
  extra_large: "xl",
  extra_extra_large: "xxl"
}, d = {
  between: "between",
  down: "down",
  not: "not",
  only: "only",
  up: "up"
}, D = "nest", i = {
  primary: {
    110: "#13496d",
    100: "#1a6799",
    90: "#1d76af",
    10: "#D3EAF8",
    5: "#E9F4FB",
    contrastText: "#FFFFFF"
  },
  secondary: {
    110: "#8B0E15",
    100: "#A21018",
    90: "#B5121B",
    10: "#FAD1D3",
    5: "#FDE8E9",
    contrastText: "#FFFFFF"
  },
  cta: {
    110: "#354F17",
    100: "#43631D",
    90: "#567F25",
    10: "#E7F4D7",
    5: "#F3F9EB",
    contrastText: "#FFFFFF"
  },
  warning: {
    110: "#AE3805",
    100: "#C13E05",
    90: "#D44406",
    10: "#6C9F2E",
    5: "#FEEDE6",
    contrastText: "#FFFFFF"
  },
  blue: {
    5: "#E9F4FB"
  },
  green: {
    110: "#354f17",
    100: "#43631d",
    90: "#567f25"
  },
  grey: {
    100: "#0D0D0D",
    90: "#1A1A1A",
    80: "#333333",
    70: "#4D4D4D",
    60: "#666666",
    50: "#808080",
    40: "#999999",
    30: "#B3B3B3",
    20: "#CCCCCC",
    10: "#E6E6E6",
    5: "#F2F2F2",
    0: "#FFFFFF"
  },
  red: {
    110: "#8b0e15",
    100: "#a21018",
    90: "#b5121b"
  },
  transparent: {
    light30: "rgba(204, 204, 204, 0.3)",
    medium30: "rgba(102, 102, 102, 0.3)",
    dark30: "rgba(51, 51, 51, 0.3)"
  }
};
function z(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var H = function(t) {
  return I(t) && !C(t);
};
function I(e) {
  return !!e && typeof e == "object";
}
function C(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || N(e);
}
var P = typeof Symbol == "function" && Symbol.for, v = P ? Symbol.for("react.element") : 60103;
function N(e) {
  return e.$$typeof === v;
}
function k(e) {
  return Array.isArray(e) ? [] : {};
}
function m(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? p(k(e), e, t) : e;
}
function Q(e, t, a) {
  return e.concat(t).map(function(l) {
    return m(l, a);
  });
}
function L(e, t) {
  if (!t.customMerge)
    return p;
  var a = t.customMerge(e);
  return typeof a == "function" ? a : p;
}
function V(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.propertyIsEnumerable.call(e, t);
  }) : [];
}
function S(e) {
  return Object.keys(e).concat(V(e));
}
function w(e, t) {
  try {
    return t in e;
  } catch {
    return !1;
  }
}
function $(e, t) {
  return w(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}
function U(e, t, a) {
  var l = {};
  return a.isMergeableObject(e) && S(e).forEach(function(n) {
    l[n] = m(e[n], a);
  }), S(t).forEach(function(n) {
    $(e, n) || (w(e, n) && a.isMergeableObject(t[n]) ? l[n] = L(n, a)(e[n], t[n], a) : l[n] = m(t[n], a));
  }), l;
}
function p(e, t, a) {
  a = a || {}, a.arrayMerge = a.arrayMerge || Q, a.isMergeableObject = a.isMergeableObject || H, a.cloneUnlessOtherwiseSpecified = m;
  var l = Array.isArray(t), n = Array.isArray(e), h = l === n;
  return h ? l ? a.arrayMerge(e, t, a) : U(e, t, a) : m(t, a);
}
p.all = function(t, a) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(l, n) {
    return p(l, n, a);
  }, {});
};
var G = p, K = G;
const X = /* @__PURE__ */ z(K), Y = {
  primary: {
    main: i.primary[110],
    light: i.primary[100],
    dark: i.primary[90],
    ...i.primary
  },
  secondary: {
    main: i.secondary[110],
    light: i.secondary[100],
    dark: i.secondary[90],
    ...i.secondary
  },
  success: {
    main: i.cta[110],
    light: i.cta[100],
    dark: i.cta[90],
    ...i.cta
  },
  blue: {
    5: i.blue[5]
  },
  green: {
    ...i.green
  },
  grey: {
    900: i.grey[100],
    800: i.grey[90],
    700: i.grey[80],
    600: i.grey[70],
    500: i.grey[60],
    400: i.grey[50],
    300: i.grey[40],
    200: i.grey[30],
    100: i.grey[20],
    50: i.grey[10],
    A100: i.grey[0],
    ...i.grey
  },
  red: {
    ...i.red
  },
  transparent: {
    ...i.transparent
  },
  warning: {
    main: i.warning[110],
    light: i.warning[100],
    dark: i.warning[90],
    ...i.warning
  }
}, g = {
  xxl: "33px",
  xl: "28px",
  lg: "23px",
  m: "18px",
  s: "16px",
  xs: "14px"
}, c = {
  xxl: "28px",
  lg: "19px",
  m: "16px",
  s: "14px",
  xs: "12px"
}, o = {
  bold: 700,
  semiBold: 600,
  regular: 400,
  thin: 300
}, s = {
  heading: "115%",
  body: "160%"
}, q = {
  fontFamily: "myriad-pro, sans-serif",
  fontWeightBold: o.bold,
  fontWeightSemiBold: o.semiBold,
  fontWeightRegular: o.regular,
  fontWeightThin: o.thin,
  h3SemiBold: {
    fontSize: g.xxl,
    fontWeight: o.semiBold,
    lineHeight: s.heading
  },
  h3SemiBoldMobile: {
    fontSize: c.xxl,
    fontWeight: o.semiBold,
    lineHeight: s.heading
  },
  h4SemiBold: {
    fontSize: g.xl,
    fontWeight: o.semiBold,
    lineHeight: s.heading
  },
  h5SemiBold: {
    fontSize: g.lg,
    fontWeight: o.semiBold,
    lineHeight: s.heading
  },
  h5SemiBoldMobile: {
    fontSize: c.lg,
    fontWeight: o.semiBold,
    lineHeight: s.heading
  },
  h6SemiBold: {
    fontSize: g.m,
    fontWeight: o.semiBold,
    lineHeight: s.heading
  },
  h6SemiBoldMobile: {
    fontSize: c.m,
    fontWeight: o.semiBold,
    lineHeight: s.heading
  },
  bodyLargeSemiBold: {
    fontSize: g.lg,
    fontWeight: o.semiBold,
    lineHeight: s.body
  },
  bodyLargeSemiBoldMobile: {
    fontSize: c.lg,
    fontWeight: o.semiBold,
    lineHeight: s.body
  },
  bodyBaseRegular: {
    fontSize: g.m,
    fontWeight: o.regular,
    lineHeight: s.body
  },
  bodyBaseRegularMobile: {
    fontSize: c.m,
    fontWeight: o.regular,
    lineHeight: s.body
  },
  bodySmallSemiBold: {
    fontSize: g.s,
    fontWeight: o.semiBold,
    lineHeight: s.body
  },
  bodySmallSemiBoldMobile: {
    fontSize: c.s,
    fontWeight: o.semiBold,
    lineHeight: s.body
  },
  bodySmallRegular: {
    fontSize: g.s,
    fontWeight: o.regular,
    lineHeight: s.body
  },
  bodySmallRegularMobile: {
    fontSize: c.s,
    fontWeight: o.regular,
    lineHeight: s.body
  },
  bodyXtraSmallRegular: {
    fontSize: g.xs,
    fontWeight: o.regular,
    lineHeight: s.body
  },
  bodyXtraSmallRegularMobile: {
    fontSize: c.xs,
    fontWeight: o.regular,
    lineHeight: s.body
  }
}, J = {
  [r.extra_small]: {
    columns: {
      full: "100%",
      gutter: "16px"
    }
  },
  [r.small]: {
    columns: {
      full: "100%",
      gutter: "16px"
    }
  },
  [r.medium]: {
    columns: {
      full: "100%",
      gutter: "16px"
    }
  },
  [r.large]: {
    columns: {
      full: "100%",
      gutter: "16px"
    }
  },
  [r.extra_large]: {
    columns: {
      full: "1152px",
      gutter: "24px",
      3: "270px"
    }
  },
  [r.extra_extra_large]: {
    columns: {
      full: "1288px",
      gutter: "32px",
      3: "298px"
    }
  }
}, Z = [
  "none",
  "0px 2px 4px 0px rgba(51, 51, 51, 0.05)",
  // xs
  "0px 8px 24px 0px rgba(51, 51, 51, 0.05)",
  // s
  "0px 10px 48px -16px rgba(51, 51, 51, 0.10)",
  // m
  "0px 20px 58px -16px rgba(51, 51, 51, 0.15)",
  // lg
  "0px 4px 4px 0px rgba(26, 26, 26, 0.32)"
], ee = {
  ribbon: 1250
}, re = {
  borderRadius: "10px",
  gridVertical: "0.5rem",
  letterBetween: "0rem",
  lineHeight: "130%"
}, te = [
  "none",
  "0px 4px 16px 0px rgba(26, 26, 26, 0.08)",
  "0px 4px 16px 0px rgba(26, 26, 26, 0.16)",
  "0px 4px 16px 0px rgba(26, 26, 26, 0.24)",
  "0px 8px 16px 0px rgba(26, 26, 26, 0.32)",
  "0px 4px 16px 0px rgba(26, 26, 26, 0.4)"
], ae = {
  breakpoints: {
    [r.small]: 0,
    [r.medium]: 640,
    [r.large]: 1200,
    [r.extra_large]: 1440
  },
  mediaQueries: {
    [r.medium]: "@media (min-width: 640px)",
    [r.large]: "@media (min-width: 1200px)",
    [r.extra_large]: "@media (min-width: 1440px)"
  },
  columns: {
    [r.small]: 4,
    [r.medium]: 6,
    [r.large]: 12,
    [r.extra_large]: 12
  },
  gutter: {
    [r.small]: "24px",
    [r.medium]: "24px",
    [r.large]: "24px",
    [r.extra_large]: "32px"
  },
  margin: {
    [r.small]: "24px",
    [r.medium]: "32px",
    [r.large]: "32px",
    [r.extra_large]: "auto"
  },
  // Hard-coded column width based on the number of columns
  // and the gutter size.
  // Formula used: 
  // calc(n * (columnWidth) + (n - 1) * gutter)
  // where n is the number of columns
  columnWidth: {
    [r.small]: {
      1: "calc((100% - 72px) / 4)",
      2: "calc(2 * ((100% - 72px) / 4) + 24px)",
      3: "calc(3 * ((100% - 72px) / 4) + 48px)",
      4: "100%"
    },
    [r.medium]: {
      1: "calc((100% - 120px) / 6)",
      2: "calc(2 * ((100% - 120px) / 6) + 24px)",
      3: "calc(3 * ((100% - 120px) / 6) + 48px)",
      4: "calc(4 * ((100% - 120px) / 6) + 72px)",
      5: "calc(5 * ((100% - 120px) / 6) + 96px)",
      6: "100%"
    },
    [r.large]: {
      1: "calc((100% - 264px) / 12)",
      2: "calc(2 * ((100% - 264px) / 12) + 24px)",
      3: "calc(3 * ((100% - 264px) / 12) + 48px)",
      4: "calc(4 * ((100% - 264px) / 12) + 72px)",
      5: "calc(5 * ((100% - 264px) / 12) + 96px)",
      6: "calc(6 * ((100% - 264px) / 12) + 120px)",
      7: "calc(7 * ((100% - 264px) / 12) + 144px)",
      8: "calc(8 * ((100% - 264px) / 12) + 168px)",
      9: "calc(9 * ((100% - 264px) / 12) + 192px)",
      10: "calc(10 * ((100% - 264px) / 12) + 216px)",
      11: "calc(11 * ((100% - 264px) / 12) + 240px)",
      12: "100%"
    },
    [r.extra_large]: {
      1: "80px",
      2: "192px",
      3: "304px",
      4: "416px",
      5: "528px",
      6: "640px",
      7: "752px",
      8: "864px",
      9: "976px",
      10: "1088px",
      11: "1200px",
      12: "1312px"
    }
  },
  // Hard-coded max-width for the container
  containerMaxWidth: {
    [r.small]: "calc(100% - 48px) ",
    [r.medium]: "calc(100% - 64px)",
    [r.large]: "calc(100% - 64px)",
    [r.extra_large]: "1312px"
  },
  /**
   * Returns sx/css styles for the grid wrapper (container)
   * accounting for margin and max-width at each breakpoint.
   */
  getGridWrapper() {
    return {
      width: this.containerMaxWidth[r.small],
      marginLeft: this.margin[r.small],
      marginRight: this.margin[r.small],
      padding: 0,
      [this.mediaQueries[r.medium]]: {
        width: this.containerMaxWidth[r.medium],
        marginLeft: this.margin[r.medium],
        marginRight: this.margin[r.medium]
      },
      [this.mediaQueries[r.large]]: {
        width: this.containerMaxWidth[r.large],
        marginLeft: this.margin[r.large],
        marginRight: this.margin[r.large]
      },
      [this.mediaQueries[r.extra_large]]: {
        width: this.containerMaxWidth[r.extra_large],
        marginLeft: this.margin[r.extra_large],
        marginRight: this.margin[r.extra_large]
      }
    };
  },
  /**
   * Returns sx/css styles for a flex “row” wrapper
   * with wrapping and responsive gutter.
   */
  getGridRowStyles() {
    return {
      display: "flex",
      flexFlow: "row wrap",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      width: "100%",
      gap: this.gutter[r.small],
      [this.mediaQueries[r.medium]]: {
        gap: this.gutter[r.medium]
      },
      [this.mediaQueries[r.large]]: {
        gap: this.gutter[r.large]
      },
      [this.mediaQueries[r.extra_large]]: {
        gap: this.gutter[r.extra_large]
      }
    };
  }
}, ie = {
  borderRadius: 10,
  borderRadiusNone: 0,
  borderRadiusXs: 2,
  borderRadiusSm: 4,
  borderRadiusLg: 12,
  borderRadiusXl: 24,
  borderRadiusFull: 360
}, x = {
  values: {
    [r.extra_small]: 0,
    [r.small]: 576,
    [r.medium]: 768,
    [r.large]: 992,
    [r.extra_large]: 1200,
    [r.extra_extra_large]: 1440
  }
}, ne = (e) => ({
  [u.global_head]: x,
  [u.standard]: x
})[e] ?? x, le = (e) => ({
  typography: q,
  palette: Y,
  spacing: (t) => `${t * 8}px`,
  shape: ie,
  shadows: Z,
  zIndex: ee,
  customSpacing: re,
  customBoxShadowInner: te,
  breakpoints: {
    ...ne(e),
    contentGrids: J
  },
  grid: ae
}), oe = (e, t = {}, a = !1) => {
  if (!e)
    throw new Error("The appName must be provided!");
  const l = Object.keys(t).length === 0 || a ? le(e) : {}, n = X(l, t);
  return W({
    cssVariables: !0,
    cssVarPrefix: D,
    ...n
  });
}, E = A(), xe = ({
  children: e,
  theme: t,
  appName: a = u.standard,
  shouldMergeWithBaseTheme: l = !1
}) => {
  const n = oe(a, t, l);
  return /* @__PURE__ */ b(E.Provider, { value: a, children: /* @__PURE__ */ M(j, { theme: n, children: [
    /* @__PURE__ */ b(T, {}),
    e
  ] }) });
}, se = () => {
  const e = O(E);
  if (!e)
    throw new Error("useAppName must be used within a DesignSystemProvider");
  return e;
}, ge = (e, t, a) => {
  if (!Object.values(d).includes(e))
    throw new Error(`Invalid method "${e}"`);
  if (!Array.isArray(t) || t.length === 0)
    throw new Error('The "values" array must contain at least one breakpoint');
  for (const l of t)
    if (l === void 0 || !Object.keys(a).includes(l))
      throw new Error(`Invalid breakpoint "${l}"`);
  if (e === d.between) {
    if (t.length !== 2)
      throw new Error('The "between" method requires two values');
    const [l, n] = t;
    if (a[l] > a[n])
      throw new Error("The first breakpoint cannot be greater than the second breakpoint");
  }
};
function he({
  method: e = null,
  values: t = null,
  defaultDesktopBreakpoint: a = r.large
}) {
  let l;
  const n = R(), F = se() === u.global_head ? r.extra_large : a;
  e && t && (ge(e, t, n.breakpoints.values), l = (() => {
    const [f, _] = t;
    switch (e) {
      case d.up:
      case d.down:
      case d.only:
      case d.not:
        return n.breakpoints[e](f);
      case d.between:
        return n.breakpoints.between(f, _);
      default:
        throw new Error(`Unsupported method "${e}"`);
    }
  })());
  const B = () => y(n.breakpoints.up(F), { noSsr: !0 });
  return {
    matches: l ? y(l, { noSsr: !0 }) : null,
    isDesktop: B,
    // As it is just for demo purposes, we don't need to compute these values in here.
    themeBreakpoints: () => n.breakpoints.values
  };
}
const fe = (e) => {
  if (typeof e != "string" || !e.trim().startsWith("--"))
    throw new Error("Invalid CSS variable name");
  return typeof window < "u" && getComputedStyle(document.body).getPropertyValue(e.trim()) || null;
};
export {
  u as APP_NAMES,
  d as BREAKPOINT_AVAILABLE_QUERY_METHODS,
  r as BREAKPOINT_DIMENSIONS,
  D as DESIGN_SYSTEM_NAME,
  xe as DesignSystemProvider,
  i as PALETTE,
  oe as createCustomTheme,
  ne as getBreakpointsByAppName,
  fe as getCssVar,
  le as getDefaultTheme,
  se as useAppName,
  he as useMediaQuery
};
